document.querySelectorAll('.product-with-accordion summary').forEach((summary) => {
  summary.addEventListener('click', function (e) {
    const ripple = document.createElement('span');
    ripple.classList.add('ripple-circle');

    const rect = summary.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;

    this.classList.add('ripple-container');
    this.appendChild(ripple);

    // Remove ripple after animation
    setTimeout(() => {
      ripple.remove();
    }, 600);
  });
});